import React from 'react';
import classNames from 'classnames';
import Paragraph from "@scentregroup/ui/components/paragraph";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let ThemeTypes = /*#__PURE__*/function (ThemeTypes) {
  ThemeTypes["fiftyFifty"] = "fiftyFifty";
  ThemeTypes["leftAligned"] = "leftAligned";
  ThemeTypes["minimal"] = "minimal";
  return ThemeTypes;
}({});
const themes = {
  [ThemeTypes.fiftyFifty]: style.fiftyFifty,
  [ThemeTypes.leftAligned]: style.leftAligned,
  [ThemeTypes.minimal]: style.minimal
};
function hasNoHours(openHourDay) {
  return !openHourDay || !openHourDay.day || !openHourDay.hours;
}
function hasNoDescription(text) {
  return !text || !text.description;
}
const DayParagraph = _ref => {
  let {
    day
  } = _ref;
  return /*#__PURE__*/_jsx(Paragraph, {
    className: style.status,
    dataTestId: "opening-hours-day",
    "data-id": "trading-hours-line_index_DayParagraph_Paragraph",
    children: day
  });
};
const HoursParagraph = _ref2 => {
  let {
    hours
  } = _ref2;
  return hours.length > 1 ? /*#__PURE__*/_jsx("span", {
    "data-id": "trading-hours-line_index_DayParagraph_span",
    children: hours.map(hour => /*#__PURE__*/_jsx(Paragraph, {
      className: style.hours,
      dataTestId: "opening-hours-hour",
      "data-id": "trading-hours-line_index_DayParagraph_Paragraph",
      children: hour
    }, hour))
  }) : /*#__PURE__*/_jsx(Paragraph, {
    className: style.hours,
    dataTestId: "opening-hours-hour",
    "data-id": "trading-hours-line_index_DayParagraph_Paragraph_3",
    children: hours
  });
};
const DescriptionText = _ref3 => {
  let {
    text
  } = _ref3;
  return hasNoDescription(text) ? null : /*#__PURE__*/_jsx(Paragraph, {
    className: text.isColored ? style.specialDescription : style.defaultDescription,
    dataTestId: "opening-hours-desc",
    "data-id": "trading-hours-line_index_DayParagraph_Paragraph_4",
    children: text.description
  });
};
const TradingHoursLine = _ref4 => {
  let {
    openHourDay,
    theme
  } = _ref4;
  if (hasNoHours(openHourDay)) {
    return null;
  }
  const {
    hours,
    day,
    text
  } = openHourDay;
  const styles = classNames(style.TradingHoursLine, style.evolved, theme && themes[theme], {
    [style.active]: day === 'Today'
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles,
    "data-test-id": "opening-hours-entry",
    "data-chromatic": "ignore",
    "data-id": "trading-hours-line_index_DayParagraph_div",
    children: [/*#__PURE__*/_jsx(DayParagraph, {
      day: day,
      "data-id": "trading-hours-line_index_div_DayParagraph"
    }), /*#__PURE__*/_jsx(HoursParagraph, {
      hours: hours,
      "data-id": "trading-hours-line_index_DayParagraph_div_HoursParagraph"
    }), /*#__PURE__*/_jsx(DescriptionText, {
      text: text,
      "data-id": "trading-hours-line_index_DayParagraph_div_DescriptionText"
    })]
  });
};
export default TradingHoursLine;